<template>
  <div class="app">
    <AppHeader fixed class="logisty-container">

      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" :to="{name: 'บริษัท'}">
        <img
          class="navbar-brand-full"
          src="/img/iconOnly_White_192.png"
          height="50"
          alt="Logisty Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="/img/iconOnly_White_192.png"
          height="50"
          alt="Logisty Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="ml-auto d-md-down-none">
        <!-- <b-nav-item class="px-3" to="#">Dashboard</b-nav-item> -->
        <!-- <b-button variant="warning" :to="{name: 'แก้ไขข้อมูลบริษัท'}" right no-caret>เพิ่มโปรไฟล์ของคุณในระบบ</b-button> -->
      </b-navbar-nav>
      <div v-if="loggedinName" class="ml-auto text-white d-md-down-none nav-current-user-data">
        {{ loggedinName }}
        <br />
        {{ loggedinEmail }}
        <br />
        {{ companyStatus }}
      </div>
      <b-navbar-nav class="ml-2">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb class="logisty-container" :list="list"/> -->
        <!-- <b-card v-if="loggedinEmail">เข้าสู่ระบบแล้วด้วยอีเมล {{ loggedinEmail }}</b-card> -->
        <div class="container-fluid mt-2">
          <!-- <ModalLoading /> -->
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside fixed> -->
      <!--aside-->
      <!-- <DefaultAside/>
      </AppAside>-->
    </div>
    <TheFooter class="logisty-container">
      <!--footer-->
      <div>
        <span class="ml-1" style="color: white;">Logisty Company Profile Webapp &copy; 2020 Logisty</span>
      </div>
    </TheFooter>
  </div>
</template>

<style>
.nav-current-user-data {
  font-size: 0.75em;
}
</style>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
// import DefaultAside from './DefaultAside'
// import SidebarNav from '../components/SidebarNav/SidebarNav'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

// import ModalLoading from '../components/ModalLoading'

import Company from '../services/http/Company'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    // DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
    // ModalLoading
  },
  data () {
    return {
      nav: nav.items,
      loggedinEmail: null,
      loggedinName: null,
      companyStatus: null
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  async mounted () {
    this.checkLogin()
    Window.Event.$on('checkLogin', this.checkLogin)
    // get company info

    try {
      let company = new Company()
      let result = await company.getCompanyInfo()
      if (result.code === 1) {
        this.loggedinName = result.data.name
        this.companyStatus = result.data.shipperStatus === 1 ? 'ยืนยันตัวตนแล้ว' : 'รอการยืนยันตัวตน'
      }
    } catch (error) {

    }
  },
  beforeDestroy () {
    Window.Event.$off('checkLogin')
  },
  methods: {
    async checkLogin () {
      if (this.$cookies.isKey('email')) {
        this.loggedinEmail = this.$cookies.get('email')
        try {
          let company = new Company()
          let result = await company.getCompanyInfo()
          if (result.code === 1) {
            this.loggedinName = result.data.name
            this.companyStatus = result.data.shipperStatus === 1 ? 'ยืนยันตัวตนแล้ว' : 'รอการยืนยันตัวตน'
          }
        } catch (error) {

        }
      }
    }
  }
}
</script>
